import React from 'react';
import './HeroInformation.scss';
import {ButtonMUI} from "../../../shared";

const HeroInformation = ({title, description,customHtml}) => {
  return (
    <div className={'hero'}>
      <h1 className={'hero__title'}>{title}</h1>
      <h3 className={`hero__description${customHtml ? ' button-down' : ''}`}>{description}</h3>
        {customHtml ? customHtml : ''}
    </div>
  );
};

export default HeroInformation;
